import { Link } from "gatsby";
import React from "react";

const BackButtonInSchedules = () => (
<div className="grid--4 grid-padding align--center" class="print_hidden">
        <Link className="button button--grey" to="/history">
          <i className="fa fa-caret-left" aria-hidden="true" /> Back
        </Link>
      </div>
);

export default BackButtonInSchedules;